import React from 'react';
import CloseModalLayout from './CloseModalLayout';
import ReactModal from 'react-modal';

const CloseDealModal = ({
  isOpen,
  deals,
  handleCloseModal,
  openBuyThirdPersonModal,
  isBuyThirdPerson,
  cashBoxId,
}) => {
  return (
    <ReactModal
      isOpen={isOpen}
      contentLabel="Modal"
      className="modal-container clientContract-modal-container"
      overlayClassName="modal-overlay">
      <CloseModalLayout
        deals={deals}
        handleCloseModal={handleCloseModal}
        openBuyThirdPersonModal={openBuyThirdPersonModal}
        isBuyThirdPerson={isBuyThirdPerson}
        cashBoxId={cashBoxId}
      />
    </ReactModal>
  );
};

export default CloseDealModal;
